import * as Yup from 'yup';

export const vesselListSchema = Yup.object({
  Description: Yup.string().required('Description is required'),
});
